import "./polyfills";
import React from "react";
import { createRoot } from "react-dom/client";

import appConfig from "@/config/app-config";
import "@fontsource/inter/200.css";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/900.css";
import "./iframe";
import "./styles/globals.css";
import "./precheck";
import { default as Soapbox } from "./containers/soapbox";
import { injectConsentChain } from "./cookies";
import { detectTvSourceFromWindow } from "./hooks/useTvSource";
import { initImpressions } from "./impressions/lifecycle";
import * as monitoring from "./monitoring";
import ready from "./ready";
import { isEmbedPath } from "./utils/embed-path";
import { registerServiceWorker } from "./utils/register-sw";

// Sentry
monitoring.start();

registerServiceWorker();

window.environment =
  appConfig.NODE_ENV === "production" ? "production" : "development";

ready(() => {
  const isTvSource = detectTvSourceFromWindow();
  const isEmbedRoute = isEmbedPath(window.location.pathname);

  if (appConfig.NODE_ENV === "production" && !isTvSource && !isEmbedRoute) {
    injectConsentChain();
  }

  initImpressions();

  const container = document.getElementById("root") as HTMLElement;
  const root = createRoot(container);
  root.render(<Soapbox />);
});
